import React from 'react';
import NewPaymentMethodForm from 'components/Payment/NewPaymentMethodForm';
import Form from 'components/UI/Form';
import { useTranslation } from 'react-i18next';
import { SelectedCard } from 'checkout';
import './CheckoutCardSelector.scss';
function CheckoutCardSelector({ showSelectedCard, showForm, cardIssuer, maskedCardNumber, expiryDateString, showEditButton, handleNewCardSubmit, handleEditCardButtonClick, }) {
    const { t } = useTranslation();
    return (React.createElement(React.Fragment, null,
        !showSelectedCard && (React.createElement(React.Fragment, null,
            React.createElement("h3", null, t('checkoutCheckoutSelectCardPaymentMethod')),
            showForm && (React.createElement(Form, { onSubmit: handleNewCardSubmit },
                React.createElement("div", { className: "checkout-card-selector__form" },
                    React.createElement(NewPaymentMethodForm, null)),
                React.createElement("button", { type: "submit", className: "checkout-card-selector__form__submit" }, "Bruk"))))),
        showSelectedCard && (React.createElement(SelectedCard, { maskedCardNumber: maskedCardNumber, cardIssuer: cardIssuer, expiryDate: expiryDateString, showEditButton: showEditButton, handleEdit: handleEditCardButtonClick }))));
}
export default CheckoutCardSelector;
